<div class="container no-filtered-offers">
  <h2 class="no-filtered-offers__header">{{ 'NO_FILTERED_OFFERS_COMPONENT.header' | translate }}</h2>
  <img class="no-filtered-offers__image" [src]="assetsService.informationDialogImageSrc" alt="">

  <p>{{ 'NO_FILTERED_OFFERS_COMPONENT.paragraph1' | translate }}</p>
  <p class="bold">{{ 'NO_FILTERED_OFFERS_COMPONENT.emphasizedParagraph' | translate }}</p>
  <p>{{ 'NO_FILTERED_OFFERS_COMPONENT.paragraph3' | translate }}</p>
  <p>{{ 'NO_FILTERED_OFFERS_COMPONENT.paragraph4' | translate }}</p>

  <div class="no-filtered-offers__button-wrapper">
    <button class="btn btn--secondary no-filtered-offers__button" (click)="resetFilters()">
      {{ 'NO_FILTERED_OFFERS_COMPONENT.actionText' | translate}}
    </button>
  </div>
</div>
